module.exports = __webpack_public_path__ + "img/trash-can-outline-svgrepo-com.aa8abda1.svg";